var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85786 3.696C5.04738 3.86391 5.04738 4.13542 4.85786 4.30154L0.825605 7.87407C0.636089 8.04198 0.329637 8.04198 0.142137 7.87407C-0.0453629 7.70616 -0.047379 7.43465 0.142137 7.26853L3.83165 3.99967L0.142137 0.730806C-0.047379 0.562897 -0.047379 0.291385 0.142137 0.125263C0.331653 -0.0408599 0.638105 -0.0426461 0.825605 0.125263L4.85786 3.69779V3.696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.714b9e72d1624a15e7d0f33ddc547ff1.svg";
export { ForwardRef as ReactComponent };